import { render, staticRenderFns } from "./ImageGroupLayout.vue?vue&type=template&id=5fb656d2&scoped=true&"
import script from "./ImageGroupLayout.vue?vue&type=script&lang=js&"
export * from "./ImageGroupLayout.vue?vue&type=script&lang=js&"
import style0 from "./ImageGroupLayout.vue?vue&type=style&index=0&id=5fb656d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb656d2",
  null
  
)

export default component.exports